var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 7.48657V2.72824H9.03695V7.48657H6.64954V0.349121L24.1574 0.349121V7.48657H21.77ZM24.6472 13.8309C25.0982 13.8309 25.4762 13.6789 25.7812 13.3749C26.0863 13.0709 26.2388 12.6942 26.2388 12.2448C26.2388 11.7954 26.0863 11.4187 25.7812 11.1147C25.4762 10.8107 25.0982 10.6587 24.6472 10.6587C24.1962 10.6587 23.8182 10.8107 23.5131 11.1147C23.2081 11.4187 23.0556 11.7954 23.0556 12.2448C23.0556 12.6942 23.2081 13.0709 23.5131 13.3749C23.8182 13.6789 24.1962 13.8309 24.6472 13.8309ZM21.77 24.4457V17.6742H9.03695V24.4457H21.77ZM24.1574 26.8248H6.64954V20.4804H0.742188V11.4518C0.742188 10.3283 1.12734 9.38655 1.89763 8.62654C2.66793 7.86656 3.60912 7.48657 4.72119 7.48657H26.0858C27.2132 7.48657 28.1582 7.86656 28.9208 8.62654C29.6835 9.38655 30.0648 10.3283 30.0648 11.4518V20.4804H24.1574V26.8248ZM27.6774 18.1012V11.4518C27.6774 11.0024 27.5249 10.6257 27.2198 10.3217C26.9148 10.0177 26.5367 9.86565 26.0858 9.86565H4.72119C4.27023 9.86565 3.89222 10.0177 3.58715 10.3217C3.28209 10.6257 3.12956 11.0024 3.12956 11.4518V18.1012H6.64954V15.2951H24.1574V18.1012H27.6774Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.c7940c34f4733c6ab31807a67188040f.svg";
export { ForwardRef as ReactComponent };